import { Badge } from '@/components/ui/badge';
import type { ComplianceStatus } from '../types';

const statusConfig: Record<ComplianceStatus, { label: string; className: string }> = {
  compliant: { label: 'Compliant', className: 'bg-green-100 text-green-800 border-green-200' },
  attention_required: { label: 'Attention Required', className: 'bg-amber-100 text-amber-800 border-amber-200' },
  non_compliant: { label: 'Non-Compliant', className: 'bg-red-100 text-red-800 border-red-200' },
  pending: { label: 'Pending', className: 'bg-slate-100 text-slate-700 border-slate-200' },
  unavailable: { label: 'Unavailable', className: 'bg-gray-100 text-gray-600 border-gray-200' },
};

interface ComplianceBadgeProps {
  status: ComplianceStatus;
}

export function ComplianceBadge({ status }: ComplianceBadgeProps) {
  const config = statusConfig[status];
  return (
    <Badge variant="outline" className={config.className}>
      {config.label}
    </Badge>
  );
}
